export default __webpack_public_path__ + "static/media/individual_card_icon.9a7480f4.svg";